import { call, put, takeLatest } from "redux-saga/effects";

import {
  addNewAccountPayble,
  fetchAccountPaybles,
  fetchOneAccountPayble,
  updateAccountPayble,
} from "./accountPayablesApi";

import {
  getAccountPayablesStart,
  getAccountPayablesSuccess,
  getAccountPayablesFailure,
  getAccountPayablesOneStart,
  addAccountPayablesStart,
  updateAccountPayablesStart,
  getAccountPayablesOneFailure,
  addAccountPayablesSuccess,
  addAccountPayablesFailure,
  updateAccountPayablesSuccess,
  updateAccountPayablesFailure,
  getAccountPayablesOneSuccess,
} from "./accountPayablesSlice";
import { showToast } from "../../../components";

function* fetchAccountPayblesSaga(action) {
  try {
    const accountPaybles = yield call(fetchAccountPaybles, action.payload);
    yield put(getAccountPayablesSuccess(accountPaybles));
  } catch (error) {
    yield put(getAccountPayablesFailure(error));
  }
}
function* fetchOneAccountPayblesSaga(action) {
  const { onSuccess, ...payload } = action.payload;
  try {
    const response = yield call(fetchOneAccountPayble, payload);
    yield put(getAccountPayablesOneSuccess(response.data));
    try {
      onSuccess?.();
    } catch (err) {
      console.error("onSuccess threw an error", err);
    }
  } catch (error) {
    yield put(getAccountPayablesOneFailure(error.message));
  }
}

function* addAccountPayblesSaga(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const response = yield call(addNewAccountPayble, payload);
    if (response.success) {
      yield put(addAccountPayablesSuccess(response.data));
      onSuccess(response.data);
      showToast("Bill has been created successfully", "success", 3000);
    } else {
      yield put(addAccountPayablesFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    console.log("error from saga", error);
    yield put(addAccountPayablesFailure(error.message));
    showToast("Unable to create the bill", "error", 3000);
  }
}

function* updateAccountPayblesSaga(action) {
  try {
    const { onSuccess, supressToast=false ,...payload} = action.payload;
    const response = yield call(updateAccountPayble, payload);
    if (response.success) {
      yield put(updateAccountPayablesSuccess(response.data));
      onSuccess?.(response.data);
      if (!supressToast) {
        showToast("Bill has been updated successfully", "success", 3000);
      }
    } else {
      yield put(updateAccountPayablesFailure(response.error));
      if (!supressToast) {
        showToast(`${response.error}`, "error", 3000);
      }
    }
  } catch (error) {
    yield put(updateAccountPayablesFailure(error.message));
    if (!supressToast) {
      showToast("Unable to update the bill", "error", 3000);
    }
    console.log("erro of updateAccountPayablesFailure",error);
  }
}

export function* watchAccountPaybles() {
  yield takeLatest(getAccountPayablesStart.type, fetchAccountPayblesSaga);
  yield takeLatest(getAccountPayablesOneStart.type, fetchOneAccountPayblesSaga);
  yield takeLatest(addAccountPayablesStart.type, addAccountPayblesSaga);
  yield takeLatest(updateAccountPayablesStart.type, updateAccountPayblesSaga);
}
